.carousel {
  border-radius: var(--radius-xl);
  padding: 56px 52px;
  background: var(--color-bg-elevated);
  border: 1px solid var(--color-border-default);
  text-align: center;
  position: relative;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.label {
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: var(--neon-lime);
  margin-bottom: 32px;
}

.slidesWrapper {
  position: relative;
  width: 100%;
  min-height: 120px;
}

.slide {
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.6s var(--ease-expo);
}

.slide[data-active="false"] {
  position: absolute;
  inset: 0;
  opacity: 0;
  transform: translateY(16px);
  pointer-events: none;
}

.slide[data-active="true"] {
  position: relative;
  opacity: 1;
  transform: translateY(0);
}

.quote {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: clamp(18px, 2.5vw, 28px);
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.4;
  margin: 0 0 24px;
  font-style: italic;
  max-width: 700px;
}

.author {
  font-family: var(--font-body);
  font-size: 14px;
  color: var(--color-text-primary);
  font-weight: 600;
}

.role {
  font-family: var(--font-body);
  font-size: 12px;
  color: var(--color-text-muted);
  margin-top: 4px;
}

.dots {
  display: flex;
  gap: 8px;
  margin-top: 32px;
}

.dot {
  height: 8px;
  border-radius: 100px;
  cursor: pointer;
  transition: all 0.4s var(--ease-expo);
  border: none;
  padding: 0;
}

.dot[data-active="true"] {
  width: 28px;
  background: var(--neon-lime);
}

.dot[data-active="false"] {
  width: 8px;
  background: rgba(255, 255, 255, 0.12);
}

@media (max-width: 768px) {
  .carousel {
    padding: 40px 24px;
  }
}
